import projection from '../generated/pwj202f1.json'; import { AcceptanceManifest } from '../types';
export const pwj202f1AcceptanceManifest = projection as AcceptanceManifest;
